export default __webpack_public_path__ + "images/parent-signup/star_icon-db8e2d26cb65b285180d469cad8078eb.svg";